import { render, staticRenderFns } from "./OrderListItemMain.vue?vue&type=template&id=70742ade&scoped=true"
import script from "./OrderListItemMain.vue?vue&type=script&lang=js"
export * from "./OrderListItemMain.vue?vue&type=script&lang=js"
import style0 from "./OrderListItemMain.vue?vue&type=style&index=0&id=70742ade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70742ade",
  null
  
)

export default component.exports